module.exports = __webpack_public_path__ + "static/media/vlog.efe9a3e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vlog.png
// module id = 404
// module chunks = 17